import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { withGuidedHouseholdReviewLayout } from 'Components/UI/guidedHouseholdReview/layoutWrapper';
import { metaOverrideSet } from './metaOverrideSet';
import { GuidedHouseholdReviewOutroScheduleLayout } from './layout';

const layout = withGuidedHouseholdReviewLayout(
  GuidedHouseholdReviewOutroScheduleLayout,
  { fullWidth: true, hideTitle: true, customButtons: true },
);

export const GuidedHouseholdReviewOutroScheduleTemplate = ({ resource }) => {
  const { loadPageContentLink, setPageContentCollection, refreshPageContentCollection } = usePageContentContext();
  return (
    <MetaResourceRenderer
      resource={resource}
      layout={layout}
      metaOverrideSet={metaOverrideSet}
      onSubmit={setPageContentCollection}
      LayoutProps={{ navigateToLink: loadPageContentLink, refresh: refreshPageContentCollection }}
    />
  );
};

GuidedHouseholdReviewOutroScheduleTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
